import {
  ActivityLinesIcon,
  ArticleIcon,
  DiamondIcon,
  GridItem,
  LayoutGrid,
  MeditationIcon,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const ICON_SIZE = 32;

const BusinessMenu = (): JSX.Element => {
  const t = useTranslations();

  return (
    <section data-cy="business-menu">
      <LayoutGrid className="mb-16 md:gap-y-16 lg:gap-y-0 lg:pb-20">
        <GridItem
          className="flex flex-col items-center justify-center gap-6 border-sandstone-400 px-5 sm:border-b-2 sm:py-16 md:border-b-0 md:border-r-2 md:py-0"
          colStart={{ sm: 'main' }}
          colEnd={{ sm: 'main', md: 12, lg: 6 }}
        >
          <DiamondIcon width={ICON_SIZE} height={ICON_SIZE} />
          <TypographyV3 align="center">
            {t('business_menu_gifting_and_rewards')}
          </TypographyV3>
        </GridItem>
        <GridItem
          className="flex flex-col items-center justify-center gap-6 border-sandstone-400 px-5 sm:border-b-2 sm:py-16 md:border-b-0 md:py-0 lg:border-r-2"
          colStart={{ sm: 'main', md: 12, lg: 6 }}
          colEnd={{ sm: 'main', lg: 12 }}
        >
          <MeditationIcon width={ICON_SIZE} height={ICON_SIZE} />
          <TypographyV3 align="center">
            {t('business_menu_employee_wellness')}
          </TypographyV3>
        </GridItem>
        <GridItem
          className="flex flex-col items-center justify-center gap-6 border-sandstone-400 px-5 sm:border-b-2 sm:py-16 md:border-b-0 md:border-r-2 md:py-0"
          colStart={{
            sm: 'main',
            lg: 12,
          }}
          colEnd={{ sm: 'main', md: 12, lg: 18 }}
        >
          <ActivityLinesIcon width={ICON_SIZE} height={ICON_SIZE} />
          <TypographyV3 align="center">
            {t('business_menu_employee_hpr')}
          </TypographyV3>
        </GridItem>
        <GridItem
          className="flex flex-col items-center justify-center gap-6 px-5 py-16 md:py-0 lg:mb-0"
          colStart={{ sm: 'main', md: 12, lg: 18 }}
          colEnd={{ sm: 'main' }}
        >
          <ArticleIcon width={ICON_SIZE} height={ICON_SIZE} />
          <TypographyV3 align="center">
            {t('business_menu_research')}
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default BusinessMenu;
